<!----
    Author: hjlee
    Description:
        이미지 슬라이더 컨트롤
---->
<template>
  <div class="image-slider3d" :image-count="contents?contents.length:0">
    <carousel-3d :controls-visible="true">
      <slide
        v-for="(file, fileIndex) in contents"
        :key="fileIndex"
        :index="fileIndex"
      >
        <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
          <div v-if="usePrimary && file.primaryFlag === 'Y'" class="thumb-primary-icon">
            <i class="fa fa-star" aria-hidden="true" />
          </div>
          <centered-image :index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="getImgUrl(file, 300)" :alt="file.fileNm" @click="clickImage" />
        </template>
      </slide>
    </carousel-3d>
    <image-viewer v-if="selectedImageSrc" ref="imageViewerRef" :src="selectedImageSrc" :alt="selectedImageName" />
  </div>
</template>

<script>
export default {
  props: {
    usePrimary: {
      type: Boolean,
      default: false
    },
    contents: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      selectedImageSrc: undefined,
      selectedImageName: undefined
    }
  },
  methods: {
    clickImage(e) {
      if ($(e.target).hasClass('current')) {
        this.selectedImageSrc = $(e.target).attr('src')
        this.selectedImageName = $(e.target).attr('alt')
        this.$nextTick(() => {
          this.showImageViewer()
        })
      }
    },
    showImageViewer() {
      this.$refs.imageViewerRef.showImageViewer()
    }
  }
}
</script>

<style scoped>
[image-count='0'] >>> .carousel-3d-controls,
[image-count='1'] >>> .carousel-3d-controls {
  display: none;
}
>>> div.carousel-3d-slide {
  cursor: pointer;
}
>>> .carousel-3d-slide {
  background-color: #eeeeee;
}
.thumb-primary-icon {
  position: absolute;
  margin-left: 5px;
}
</style>
